export interface BulkToggleConfig {
  isCollapsed: boolean;
  label: string;
  onClick: () => void;
}

interface ResolveBulkToggleConfigParams {
  hasAiStatuses: boolean;
  areAllAiStatusesCollapsed: boolean;
  areAllStatusesCollapsed: boolean;
  showAiStatusesLabel: string;
  hideAiStatusesLabel: string;
  showAllStatusesLabel: string;
  hideAllStatusesLabel: string;
  expandAiStatuses: () => void;
  collapseAiStatuses: () => void;
  expandAllStatuses: () => void;
  collapseAllStatuses: () => void;
}

export const resolveBulkToggleConfig = ({
  hasAiStatuses,
  areAllAiStatusesCollapsed,
  areAllStatusesCollapsed,
  showAiStatusesLabel,
  hideAiStatusesLabel,
  showAllStatusesLabel,
  hideAllStatusesLabel,
  expandAiStatuses,
  collapseAiStatuses,
  expandAllStatuses,
  collapseAllStatuses,
}: ResolveBulkToggleConfigParams): BulkToggleConfig => {
  if (hasAiStatuses) {
    return {
      isCollapsed: areAllAiStatusesCollapsed,
      label: areAllAiStatusesCollapsed
        ? showAiStatusesLabel
        : hideAiStatusesLabel,
      onClick: areAllAiStatusesCollapsed
        ? expandAiStatuses
        : collapseAiStatuses,
    };
  }

  return {
    isCollapsed: areAllStatusesCollapsed,
    label: areAllStatusesCollapsed
      ? showAllStatusesLabel
      : hideAllStatusesLabel,
    onClick: areAllStatusesCollapsed ? expandAllStatuses : collapseAllStatuses,
  };
};
